import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Settings as SettingsIcon, User, Shield, Bell } from 'lucide-react';

export const Settings = () => {
  return (
    <>
      {/* Settings Overview */}
      <div className='mb-8'>
        <h2 className='text-3xl font-bold text-white mb-2'>Settings</h2>
        <p className='text-slate-400'>
          Manage your account settings and application preferences.
        </p>
      </div>

      {/* Settings Cards */}
      <div className='grid gap-6 md:grid-cols-2 lg:grid-cols-3'>
        <Card className='bg-slate-800 border-slate-700'>
          <CardHeader>
            <CardTitle className='text-white flex items-center gap-2'>
              <User className='h-5 w-5' />
              Profile Settings
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className='text-slate-400 text-sm mb-4'>
              Update your personal information and profile preferences.
            </p>
            <Button variant='outline' className='w-full'>
              Edit Profile
            </Button>
          </CardContent>
        </Card>

        <Card className='bg-slate-800 border-slate-700'>
          <CardHeader>
            <CardTitle className='text-white flex items-center gap-2'>
              <Shield className='h-5 w-5' />
              Security
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className='text-slate-400 text-sm mb-4'>
              Manage your password and security settings.
            </p>
            <Button variant='outline' className='w-full'>
              Security Settings
            </Button>
          </CardContent>
        </Card>

        <Card className='bg-slate-800 border-slate-700'>
          <CardHeader>
            <CardTitle className='text-white flex items-center gap-2'>
              <Bell className='h-5 w-5' />
              Notifications
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className='text-slate-400 text-sm mb-4'>
              Configure how you receive notifications.
            </p>
            <Button variant='outline' className='w-full'>
              Notification Settings
            </Button>
          </CardContent>
        </Card>
      </div>
    </>
  );
}; 